import React from "react";
import {
  Modal,
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
  Checkbox,
  Table,
} from "react-bootstrap";
import moment from "moment";
import axios from "../../axios-atis";
import { toast } from "react-toastify";

export const CLOSE_OLD_DEFAULT_RESUME = "Intervention traitée et clôturée.";

const MONTH_NAMES = [
  "janvier", "février", "mars", "avril", "mai", "juin",
  "juillet", "août", "septembre", "octobre", "novembre", "décembre",
];
const YEAR_CHOICES = (() => {
  const list = [];
  for (let y = moment().year(); y >= 2018; y--) list.push(y);
  return list;
})();

const STATUS_CHOICES = [
  { code: 0, label: "Envoyée" },
  { code: 3, label: "Planifiée" },
  { code: 7, label: "Message laissé" },
];

/**
 * Clôture en masse des anciennes demandes (admin).
 * Étape 1 : critères → aperçu (dry run côté API, rien n'est modifié).
 * Étape 2 : confirmation → clôture réelle.
 * props : show, onClose(), onDone(result)
 */
export default class CloseOldModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState();
  }

  initialState() {
    return {
      month: moment().subtract(1, "month").month(), // 0-11
      year: moment().subtract(1, "month").year(),
      statuses: [0, 3, 7],
      resume: CLOSE_OLD_DEFAULT_RESUME,
      sendMail: false,
      preview: null, // liste renvoyée par le dry run
      selected: [], // ids cochés dans l'aperçu
      loading: false,
      done: null, // résultat final
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show && !this.props.show) {
      this.setState(this.initialState());
    }
  }

  toggleStatus = (code) => {
    const { statuses } = this.state;
    const next = statuses.indexOf(code) >= 0 ? statuses.filter((s) => s !== code) : [...statuses, code];
    this.setState({ statuses: next, preview: null });
  };

  payload(dryRun) {
    const start = moment({ year: this.state.year, month: this.state.month, day: 1 }).startOf("month");
    const end = start.clone().endOf("month");
    const p = {
      from: start.format("DD/MM/YYYY"),
      to: end.format("DD/MM/YYYY"),
      statuses: this.state.statuses,
      resume: this.state.resume,
      sendMail: this.state.sendMail,
      dryRun,
    };
    if (!dryRun) p.ids = this.state.selected;
    return p;
  }

  toggleOne = (id) => {
    const { selected } = this.state;
    this.setState({
      selected: selected.indexOf(id) >= 0 ? selected.filter((x) => x !== id) : [...selected, id],
    });
  };

  toggleAll = () => {
    const { preview, selected } = this.state;
    this.setState({ selected: selected.length === preview.length ? [] : preview.map((r) => r.id) });
  };

  preview = () => {
    if (this.state.statuses.length === 0) {
      toast.error("Choisir au moins un statut");
      return;
    }
    this.setState({ loading: true });
    axios
      .post("/requests/close-old", this.payload(true))
      .then((response) => {
        const list = response.data && Array.isArray(response.data.result) ? response.data.result : [];
        this.setState({ preview: list, selected: list.map((r) => r.id), loading: false });
      })
      .catch((error) => {
        toast.error("Erreur lors de l'aperçu : " + (error.message || error));
        this.setState({ loading: false });
      });
  };

  confirm = () => {
    this.setState({ loading: true });
    axios
      .post("/requests/close-old", this.payload(false))
      .then((response) => {
        const result = response.data ? response.data.result : null;
        this.setState({ done: result, loading: false });
        if (result) {
          toast.success(`${result.closed} demande(s) clôturée(s)`);
          if (result.mailErrors > 0) {
            toast.warn(`${result.mailErrors} mail(s) en erreur`);
          }
        }
        if (this.props.onDone) this.props.onDone(result);
      })
      .catch((error) => {
        toast.error("Erreur lors de la clôture : " + (error.message || error));
        this.setState({ loading: false });
      });
  };

  renderCriteria() {
    const { month, year, statuses, resume, sendMail } = this.state;
    return (
      <div>
        <FormGroup>
          <ControlLabel>Mois de création des demandes</ControlLabel>
          <div style={{ display: "flex", gap: "10px" }}>
            <FormControl
              componentClass="select"
              value={month}
              style={{ width: "220px" }}
              onChange={(e) => this.setState({ month: parseInt(e.target.value, 10), preview: null })}
            >
              {MONTH_NAMES.map((name, i) => (
                <option key={i} value={i}>
                  {name}
                </option>
              ))}
            </FormControl>
            <FormControl
              componentClass="select"
              value={year}
              style={{ width: "120px" }}
              onChange={(e) => this.setState({ year: parseInt(e.target.value, 10), preview: null })}
            >
              {YEAR_CHOICES.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </FormControl>
          </div>
          <small>Un mois à la fois : la recherche reste rapide. Recommence pour un autre mois.</small>
        </FormGroup>
        <FormGroup>
          <ControlLabel>Statuts concernés</ControlLabel>
          <div>
            {STATUS_CHOICES.map((s) => (
              <Checkbox
                inline
                key={s.code}
                checked={statuses.indexOf(s.code) >= 0}
                onChange={() => this.toggleStatus(s.code)}
              >
                {s.label}
              </Checkbox>
            ))}
          </div>
        </FormGroup>
        <FormGroup>
          <ControlLabel>Résumé d'intervention enregistré sur chaque demande</ControlLabel>
          <FormControl
            componentClass="textarea"
            rows="3"
            value={resume}
            onChange={(e) => this.setState({ resume: e.target.value })}
          />
        </FormGroup>
        <Checkbox checked={sendMail} onChange={(e) => this.setState({ sendMail: e.target.checked })}>
          Envoyer le mail « Résumé de l'intervention » à chaque client (déconseillé pour un nettoyage)
        </Checkbox>
      </div>
    );
  }

  renderPreview() {
    const { preview, selected, sendMail } = this.state;
    if (preview.length === 0) {
      return <p>Aucune demande ne correspond à ces critères.</p>;
    }
    const allChecked = selected.length === preview.length;
    return (
      <div>
        <p>
          <b>{selected.length}</b> demande(s) cochée(s) sur {preview.length} vont passer en <b>Traitée</b>, datées
          d'aujourd'hui,{sendMail ? " AVEC envoi d'un mail à chaque client." : " sans mail client."}
          <br />
          <small>Décoche celles à conserver.</small>
        </p>
        <div style={{ maxHeight: "45vh", overflowY: "auto" }}>
          <Table condensed striped hover>
            <thead>
              <tr>
                <th style={{ width: "30px" }}>
                  <input type="checkbox" checked={allChecked} onChange={this.toggleAll} title="Tout / rien" />
                </th>
                <th>N°</th>
                <th>Intitulé</th>
                <th>Client</th>
                <th>Créée le</th>
              </tr>
            </thead>
            <tbody>
              {preview.map((r) => (
                <tr key={r.id} onClick={() => this.toggleOne(r.id)} style={{ cursor: "pointer" }}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selected.indexOf(r.id) >= 0}
                      onChange={() => this.toggleOne(r.id)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>
                  <td>{r.numRequest}</td>
                  <td>{r.name}</td>
                  <td>{r.company}</td>
                  <td>{r.createdAt}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }

  render() {
    const { show, onClose } = this.props;
    const { preview, loading, done } = this.state;
    return (
      <Modal show={show} onHide={loading ? () => {} : onClose} bsSize="large">
        <Modal.Header closeButton={!loading}>
          <Modal.Title>Clôturer les anciennes demandes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {done ? (
            <p>
              <b>{done.closed}</b> demande(s) clôturée(s) sur {done.candidates}.
              {done.mailErrors > 0 ? ` ${done.mailErrors} mail(s) en erreur.` : ""}
            </p>
          ) : preview === null ? (
            this.renderCriteria()
          ) : (
            this.renderPreview()
          )}
        </Modal.Body>
        <Modal.Footer>
          {done ? (
            <Button bsStyle="primary" onClick={onClose}>
              Fermer
            </Button>
          ) : preview === null ? (
            <span>
              <Button onClick={onClose} disabled={loading}>
                Annuler
              </Button>{" "}
              <Button bsStyle="primary" onClick={this.preview} disabled={loading}>
                <span className="fa fa-search" />
                &nbsp;{loading ? "Recherche…" : "Aperçu"}
              </Button>
            </span>
          ) : (
            <span>
              <Button onClick={() => this.setState({ preview: null })} disabled={loading}>
                Retour
              </Button>{" "}
              <Button
                bsStyle="danger"
                onClick={this.confirm}
                disabled={loading || this.state.selected.length === 0}
              >
                <span className="fa fa-check" />
                &nbsp;{loading ? "Clôture…" : `Clôturer ${this.state.selected.length} demande(s)`}
              </Button>
            </span>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Modal/CloseOldModal.js